__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@p81-webclient/perimeter81-webclient";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@emotion/cache", "11.14.0", () => (() => (__webpack_require__(27725))), 1);
			register("@emotion/react", "11.7.1", () => (() => (__webpack_require__(27569))), 1);
			register("@emotion/styled", "11.6.0", () => (() => (__webpack_require__(45903))), 1);
			register("@mui/material", "5.5.2", () => (() => (__webpack_require__(542))), 1);
			register("@mui/private-theming/ThemeProvider", "0", () => (() => (__webpack_require__(2809))), 1);
			register("@mui/private-theming/useTheme", "0", () => (() => (__webpack_require__(3279))), 1);
			register("@mui/styled-engine", "5.16.14", () => (() => (__webpack_require__(53778))), 1);
			register("@mui/styles/makeStyles", "0", () => (() => (__webpack_require__(92233))), 1);
			register("@mui/system", "5.5.2", () => (() => (__webpack_require__(28796))), 1);
			register("@p81-common/shell-core-js", "v1.2.12", () => (() => (__webpack_require__(36779))), 1);
			register("@p81-common/ui/ui.umd.css", "3.29.0", () => (() => (__webpack_require__(85422))), 1);
			register("@p81-common/ui/v2/main-title", "3.29.0", () => (() => (__webpack_require__(64232))), 1);
			register("@p81-common/ui/v2/variables.css", "3.29.0", () => (() => (__webpack_require__(42942))), 1);
			register("@p81-common/ui", "3.29.0", () => (() => (__webpack_require__(37115))), 1);
			register("final-form-arrays", "3.1.0", () => (() => (__webpack_require__(1863))), 1);
			register("final-form", "4.20.10", () => (() => (__webpack_require__(79811))), 1);
			register("i18next", "22.5.1", () => (() => (__webpack_require__(342))), 1);
			register("i18next", "23.3.0", () => (() => (__webpack_require__(44978))), 1);
			register("react-dom", "17.0.2", () => (() => (__webpack_require__(97950))), 1);
			register("react-final-form-arrays", "3.1.4", () => (() => (__webpack_require__(56747))), 1);
			register("react-final-form", "6.5.9", () => (() => (__webpack_require__(77775))), 1);
			register("react-i18next", "12.3.1", () => (() => (__webpack_require__(32687))), 1);
			register("react-i18next", "13.0.2", () => (() => (__webpack_require__(6242))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(97508))), 1);
			register("react-router-dom", "5.2.0", () => (() => (__webpack_require__(62582))), 1);
			register("react-router-dom", "5.3.0", () => (() => (__webpack_require__(91006))), 1);
			register("react", "17.0.2", () => (() => (__webpack_require__(65043))), 1);
			register("redux-reducers-injector", "0.3.0", () => (() => (__webpack_require__(40421))), 1);
			register("redux-saga", "1.1.1", () => (() => (__webpack_require__(77428))), 1);
			register("redux-sagas-injector", "1.1.1", () => (() => (__webpack_require__(5348))), 1);
			register("redux-thunk", "2.3.0", () => (() => (__webpack_require__(63708))), 1);
			register("redux-thunk", "2.4.2", () => (() => (__webpack_require__(12171))), 1);
			register("redux", "4.0.4", () => (() => (__webpack_require__(26522))), 1);
			register("redux", "4.0.5", () => (() => (__webpack_require__(50805))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(71297))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(72087))), 1);
			register("safervpn-storybook", "1.7.47", () => (() => (__webpack_require__(72953))), 1);
			initExternal(83000);
			initExternal(79453);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};